import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { LivErrorResponse } from '@app/core/models/liv-response-protocol.model';

import { getRemoteError } from '../helpers/get-remote-error';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return 'Sem conexão com a internet';
    }

    return error.message ? error.message : JSON.stringify(error);
  }

  getClientStack(error: Error): string {
    return error.stack ?? '';
  }

  getServerMessage(error: HttpErrorResponse | LivErrorResponse): string {
    return getRemoteError(error).message;
  }

  getServerStack(error: HttpErrorResponse | LivErrorResponse): string {
    if (error instanceof HttpErrorResponse) {
      return '';
    }

    return JSON.stringify(error.error?.stack ?? {});
  }
}
